// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.forms.FormDataContent
import io.ktor.client.request.forms.MultiPartFormDataContent
import io.ktor.client.request.forms.formData
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.Parameters
import io.ktor.http.content.PartData
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.network.model.entity.noncore.Document

@OptIn(InternalKtorfitApi::class)
public class _DocumentServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : DocumentService {
  override suspend fun getDocuments(entityType: String, entityId: Int): Flow<List<Document>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$entityType".encodeURLPath()}/${"$entityId".encodeURLPath()}/documents")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Document>>>(),)!! 
  }

  override suspend fun createDocument(
    entityType: String,
    entityId: Int,
    nameOfDocument: String,
    description: String,
    typedFile: PartData,
  ): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "${"$entityType".encodeURLPath()}/${"$entityId".encodeURLPath()}/documents")
        }
        val __formData = formData {
        nameOfDocument?.let{ append("name", "${it}") }
        description?.let{ append("description", "${it}") }
        typedFile?.let{ append("typedFile", "${it}") }
        }
        setBody(MultiPartFormDataContent(__formData))
         
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }

  override suspend fun createDocumentFile(
    entityType: String,
    entityId: Long,
    `file`: MultiPartFormDataContent,
  ) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "${"$entityType".encodeURLPath()}/${"$entityId".encodeURLPath()}/documents")
        }
        setBody(file) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun downloadDocument(
    entityType: String,
    entityId: Int,
    documentId: Int,
  ): Flow<Document> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$entityType".encodeURLPath()}/${"$entityId".encodeURLPath()}/documents/${"$documentId".encodeURLPath()}/attachment")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Document>>(),)!! 
  }

  override suspend fun removeDocument(
    entityType: String,
    entityId: Int,
    documentId: Int,
  ): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "${"$entityType".encodeURLPath()}/${"$entityId".encodeURLPath()}/documents/${"$documentId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }

  override suspend fun updateDocument(
    entityType: String,
    entityId: Int,
    documentId: Int,
    nameOfDocument: String,
    description: String,
    typedFile: PartData,
  ): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "${"$entityType".encodeURLPath()}/${"$entityId".encodeURLPath()}/documents/${"$documentId".encodeURLPath()}")
        }
        val __formData = formData {
        nameOfDocument?.let{ append("name", "${it}") }
        description?.let{ append("description", "${it}") }
        typedFile?.let{ append("typedFile", "${it}") }
        }
        setBody(MultiPartFormDataContent(__formData))
         
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }
}

public class _DocumentServiceProvider : ClassProvider<DocumentService> {
  override fun create(_ktorfit: Ktorfit): DocumentService = _DocumentServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createDocumentService(): DocumentService = _DocumentServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
